import { PromoCodeErrorResponse } from "utils/interfaces"

function isPromoCodeErrorResponse(apiError: string): apiError is PromoCodeErrorResponse {
    const values = Object.values(PromoCodeErrorResponse) as string[]
    return values.includes(apiError)
}

export function getErrorDescription(apiError: string) {
    if (!apiError) return ""
    if (isPromoCodeErrorResponse(apiError)) {
        switch (apiError) {
            case PromoCodeErrorResponse.NoDiscount:
                return "Промокод не\u00a0найден."
            case PromoCodeErrorResponse.Expired:
                return "Промокод истек."
            case PromoCodeErrorResponse.CompanyBalanceUsedUp:
                return (
                    "Промокод неактивен. Обратитесь, пожалуйста, к\u00a0коллеге, " +
                    "ответственному за\u00a0корпоративные скидки в\u00a0вашей компании."
                )
            case PromoCodeErrorResponse.CanNotBeAppliedByThisEmail:
            case PromoCodeErrorResponse.UnavailableForClient:
                return "Промокод недоступен этому пользователю."
            case PromoCodeErrorResponse.NoPsychologist:
            case PromoCodeErrorResponse.UnsuitablePsychologist:
            case PromoCodeErrorResponse.NoOfferedService:
            case PromoCodeErrorResponse.PriceLimitExceeded:
            case PromoCodeErrorResponse.NoRemainder:
                return "Промокод не\u00a0может быть применен."
            case PromoCodeErrorResponse.Duplicate:
                return "Промокод уже добавлен."
            case PromoCodeErrorResponse.NotAvailableForB2B:
                return "Нельзя зарегистрироваться с\u00a0этим промокодом."
            case PromoCodeErrorResponse.LoginRequired:
                return ""
            default:
                return "Промокод не\u00a0найден или не\u00a0может быть применен."
        }
    }
    return ""
}
